// extracted by mini-css-extract-plugin
export default {"defaultCheckoutWrapper":"IneD_P","checkoutWrapper":"lUz52I"};